export const ALLOW_PLAN_UPGRADE_PARTNER_ID_LIST = [75457, 76294, 239374]
